// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --app-btn-primary: var(--e-global-color-primary);
  --app-btn-primary-strong: #5a337c;
  --app-btn-primary-weak: #efe7f7;
  --app-btn-danger: #c44762;
  --app-btn-danger-strong: #aa3a54;
  --app-btn-neutral: #f7f8fb;
  --app-btn-border: #d6dce7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  font-weight: 600;
  line-height: 1.1;
  padding: 10px 16px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  text-decoration: none;
  background: var(--app-btn-primary);
  color: #ffffff;
  box-shadow: 0 10px 30px rgba(107, 64, 146, 0.24);
}

:host(:hover:not(:disabled):not(.app-button--link)) {
  transform: translateY(-1px);
  box-shadow: 0 12px 32px rgba(107, 64, 146, 0.28);
}

:host(:active:not(:disabled):not(.app-button--link)) {
  transform: translateY(0);
  box-shadow: 0 8px 20px rgba(107, 64, 146, 0.2);
}

:host(:focus-visible) {
  outline: 3px solid rgba(92, 107, 192, 0.3);
  outline-offset: 2px;
}

:host(:disabled),
:host(.disabled),
:host([aria-disabled=true]) {
  cursor: not-allowed;
  opacity: 0.7;
  box-shadow: none;
}

:host(.app-button--secondary) {
  background: var(--app-btn-neutral);
  color: #1f2937;
  border-color: var(--app-btn-border);
  box-shadow: none;
}

:host(.app-button--secondary:hover:not(:disabled)) {
  color: #111827;
  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.08);
}

:host(.app-button--ghost) {
  background: transparent;
  border-color: var(--app-btn-border);
  color: #1f2937;
  box-shadow: none;
}

:host(.app-button--ghost:hover:not(:disabled)) {
  background: var(--app-btn-neutral);
  color: #111827;
}

:host(.app-button--danger) {
  background: var(--app-btn-danger);
  border-color: var(--app-btn-danger-strong);
  box-shadow: 0 10px 30px rgba(196, 71, 98, 0.25);
}

:host(.app-button--danger:hover:not(:disabled)) {
  background: var(--app-btn-danger-strong);
  box-shadow: 0 12px 32px rgba(170, 58, 84, 0.3);
}

:host(.app-button--link) {
  background: transparent;
  border: none;
  color: var(--app-btn-primary);
  padding: 0;
  box-shadow: none;
  font-weight: 600;
}

:host(.app-button--link:hover:not(:disabled)) {
  color: #3e4fa3;
  text-decoration: underline;
  transform: none;
}

:host(.app-button--link:active:not(:disabled)) {
  transform: none;
}

:host(.app-button--sm) {
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 0.95rem;
}

:host(.app-button--block) {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-shared/button/button.component.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;EACA,iCAAA;EACA,+BAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,yBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,2HAAA;EAEA,qBAAA;EACA,kCAAA;EACA,cAAA;EACA,gDAAA;AADF;;AAIA;EACE,2BAAA;EACA,gDAAA;AADF;;AAIA;EACE,wBAAA;EACA,8CAAA;AADF;;AAIA;EACE,0CAAA;EACA,mBAAA;AADF;;AAIA;;;EAGE,mBAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,kCAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,6CAAA;AADF;;AAIA;EACE,uBAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,kCAAA;EACA,cAAA;AADF;;AAIA;EACE,iCAAA;EACA,0CAAA;EACA,+CAAA;AADF;;AAIA;EACE,wCAAA;EACA,8CAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;AADF","sourcesContent":[":host {\n  --app-btn-primary: var(--e-global-color-primary);\n  --app-btn-primary-strong: #5a337c;\n  --app-btn-primary-weak: #efe7f7;\n  --app-btn-danger: #c44762;\n  --app-btn-danger-strong: #aa3a54;\n  --app-btn-neutral: #f7f8fb;\n  --app-btn-border: #d6dce7;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 12px;\n  font-weight: 600;\n  line-height: 1.1;\n  padding: 10px 16px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease,\n    color 0.2s ease;\n  text-decoration: none;\n  background: var(--app-btn-primary);\n  color: #ffffff;\n  box-shadow: 0 10px 30px rgba(107, 64, 146, 0.24);\n}\n\n:host(:hover:not(:disabled):not(.app-button--link)) {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 32px rgba(107, 64, 146, 0.28);\n}\n\n:host(:active:not(:disabled):not(.app-button--link)) {\n  transform: translateY(0);\n  box-shadow: 0 8px 20px rgba(107, 64, 146, 0.2);\n}\n\n:host(:focus-visible) {\n  outline: 3px solid rgba(92, 107, 192, 0.3);\n  outline-offset: 2px;\n}\n\n:host(:disabled),\n:host(.disabled),\n:host([aria-disabled='true']) {\n  cursor: not-allowed;\n  opacity: 0.7;\n  box-shadow: none;\n}\n\n:host(.app-button--secondary) {\n  background: var(--app-btn-neutral);\n  color: #1f2937;\n  border-color: var(--app-btn-border);\n  box-shadow: none;\n}\n\n:host(.app-button--secondary:hover:not(:disabled)) {\n  color: #111827;\n  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.08);\n}\n\n:host(.app-button--ghost) {\n  background: transparent;\n  border-color: var(--app-btn-border);\n  color: #1f2937;\n  box-shadow: none;\n}\n\n:host(.app-button--ghost:hover:not(:disabled)) {\n  background: var(--app-btn-neutral);\n  color: #111827;\n}\n\n:host(.app-button--danger) {\n  background: var(--app-btn-danger);\n  border-color: var(--app-btn-danger-strong);\n  box-shadow: 0 10px 30px rgba(196, 71, 98, 0.25);\n}\n\n:host(.app-button--danger:hover:not(:disabled)) {\n  background: var(--app-btn-danger-strong);\n  box-shadow: 0 12px 32px rgba(170, 58, 84, 0.3);\n}\n\n:host(.app-button--link) {\n  background: transparent;\n  border: none;\n  color: var(--app-btn-primary);\n  padding: 0;\n  box-shadow: none;\n  font-weight: 600;\n}\n\n:host(.app-button--link:hover:not(:disabled)) {\n  color: #3e4fa3;\n  text-decoration: underline;\n  transform: none;\n}\n\n:host(.app-button--link:active:not(:disabled)) {\n  transform: none;\n}\n\n:host(.app-button--sm) {\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-size: 0.95rem;\n}\n\n:host(.app-button--block) {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
